import React from "react"
import { useTranslation } from "react-i18next"

import { useApiContext } from "~/api"
import { Attachment } from "~/components/Attachment/Attachment"
import { Card } from "~/components/Card/Card"
import { Heading } from "~/components/Heading/Heading"
import { Link } from "~/components/Link/Link"
import { Raw } from "~/components/raw"
import { Wrapper } from "~/components/Wrapper/Wrapper"

import styles from "./index.module.css"

export const Principles: React.FC = () => {
  const { t } = useTranslation()
  const { principes, cards, docs } = useApiContext("/sustainable/page")
  const { text } = principes

  const { items: documentElementsSocialReportsItems } = useApiContext("/documents/elements")

  return (
    <Wrapper>
      <div className="container grid grid--col-12">
        <div className={styles.Head}>
          <Heading as="h2" className={styles.Title} like="h1">
            <Raw html={t("sustainable-development.Principles.Title")} />
          </Heading>

          <Link href="/sustainable-development/responsible-investment-principles" view="arrow">
            <Raw html={t("sustainable-development.Principles.Link")} />
          </Link>
        </div>

        <div className={styles.Content}>
          <div className={styles.ColLeft}>
            <div className={styles.List} dangerouslySetInnerHTML={{ __html: text }} />

            <div className={styles.Attachments}>
              {docs.map(({ name, file }, i) => {
                if (file.link) {
                  return (
                    <Attachment
                      key={i}
                      className={styles.Attachment}
                      format={file.format}
                      link={file.link}
                      sizeValue={file.sizeValue}
                      title={name}
                    />
                  )
                }
              })}
            </div>

            {!!documentElementsSocialReportsItems && !!documentElementsSocialReportsItems.length && (
              <div className={styles.Block}>
                <Heading className={styles.SubTitle} like="h2">
                  <Raw html={t("sustainable-development.Principles.Block.01.SubTitle")} />
                </Heading>

                <Link href="/sustainable-development/non-financial-reporting" view="arrow">
                  <Raw html={t("sustainable-development.Principles.Block.Link")} />
                </Link>

                {documentElementsSocialReportsItems
                  .filter(({ showOnSustainability }) => showOnSustainability !== null)
                  .map(({ name, fileData }, i) => {
                    if (fileData.link) {
                      return (
                        <Attachment
                          key={i}
                          className={styles.BlockAttachment}
                          format={fileData.format}
                          link={fileData.link}
                          sizeValue={fileData.sizeValue}
                          title={name}
                        />
                      )
                    }
                  })}
              </div>
            )}

            <div className={styles.Block}>
              <Heading className={styles.SubTitle} like="h2">
                <Raw html={t("sustainable-development.Principles.Block.02.SubTitle")} />
              </Heading>

              <Link href="/about/corpmanage/committee-strategy-esg" view="arrow">
                <Raw html={t("sustainable-development.Principles.Block.Link")} />
              </Link>

              <div className={styles.BlockAttachment}>
                <Raw html={t("sustainable-development.Principles.Block.02.Description")} />
              </div>
            </div>
          </div>

          <div className={styles.ColRight}>
            {cards.map(({ name, text, link, picture }, i) => (
              <Card key={i} className={styles.CardWrapper}>
                <div className={styles.CardHead}>
                  <div className={styles.CardLogo}>
                    <img src={picture} />
                  </div>

                  <Heading like="h4">
                    <Raw html={name} />
                  </Heading>
                </div>

                <div
                  dangerouslySetInnerHTML={{
                    __html: text,
                  }}
                />

                <Link
                  className={styles.CardLink}
                  href={link}
                  rel="noopener noreferrer"
                  target="_blank"
                  view="arrow"
                >
                  <Raw html={t("sustainable-development.Principles.Card.Link")} />
                </Link>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </Wrapper>
  )
}
